import { render, staticRenderFns } from "./LegalAccordion.vue?vue&type=template&id=4feb4f6a&scoped=true"
import script from "./LegalAccordion.vue?vue&type=script&lang=js"
export * from "./LegalAccordion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4feb4f6a",
  null
  
)

export default component.exports